export function fiScrollBlockToElement(blockElement: Element, childElement: Element) {
    const blockRect = blockElement.getBoundingClientRect(),
        childRect = childElement.getBoundingClientRect();
    if (childRect.top < blockRect.top) {
        blockElement.scrollTop -= blockRect.top - childRect.top;
    } else if (childRect.bottom > blockRect.bottom) {
        blockElement.scrollTop += childRect.bottom - blockRect.bottom;
    }
}
